import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import MyPage from "../../MyPage.js";
import SubTabsWarehouses from "../../SubTabsWarehouses.js";
import { Blocks } from 'react-loader-spinner'
import axiosService from '../../helpers/axios';
  export default class WarehousesTransfertsPoDealay extends Component{ 

    constructor(props){
        super(props);
  
        this.state={
            transferts:[],
            modalTitle:"",
            
              transfertid: 0,
              yearid: 0,
              from_warehouseid: 0,
              to_warehouseid: 0,
              productid: 0,
              july:"",
              august: "",
              september:"",
              october: "",
              november:"",
              december:"",
              january: "",
              february: "",
              march: "",
              april: "",
              may: "",
              june: "",
              povalidatedjuly: false,
                povalidatedaugust: false,
                povalidatedseptember: false,
                povalidatedoctober: false,
                povalidatednovember: false,
                povalidateddecember: false,
                povalidatedjanuary: false,
                povalidatedfebruary: false,
                povalidatedmarch: false,
                povalidatedapril: false,
                povalidatedmay: false,
                povalidatedjune: false,
              from_warehouse: {
                warehouseid: 0,
                warehousename: "",
                countryid: 0
              },
              to_warehouse: {
                warehouseid: 0,
                warehousename: "",
                countryid: 0
              },
              year: {
                yearid: 0,
                fyname: "",
                isactive: true
              },
              product: {
                productid: 0,
                sapcode: "",
                productdescription: "",
                itemtype: {
                  itemtypeid: 0,
                  itemtypename: ""
                }
              },
              comment:"",
   
      kits:[],
      products:[],
      productLabels:[],
      productlabelname:"",
      
  
            
            TransfertIdFilter:"",
            ProductIdFilter:"",
            ProductDescriptionFilter:"",
            ItemTypeFilter:"",
            FiscalYearFilter:"",
            RegionNameFilter:"",
            CountryNameFilter:"",
            FromWarehouseNameFilter:"",
            ToWarehouseNameFilter:"",
            TransfertCommentFilter:"",
            transfertsWithoutFilter:[],
  
  
         
            
            ForecastCommentOFilter:"",
            CurrentYearFilter:"",
            
            forecastsHistoryWithoutFilter:[],
            regionNames: [],
            countryNames: [],
            fiscalYears: [], 
            productdescriptions: [],
            warehouseNames: [],
            toWarehouseNames: [],
            loading: true,
            isEditClicked: false,
            fiscalYear:"",
            fiscalMonth:"",
  
            stockprocurement:[],
           
            stockviewid:0,
            fyname_o:"",
            regionname_o:"",
            warehousename_o:"",
            productid_o:0,
            sapcode_o:"",
            productdescription_o:"",
            itemtypename_o:"",
            july_o:"",
            august_o:"",
            september_o:"",
            october_o: "",
            november_o: "",
            december_o: "",
            january_o: "",
            february_o: "",
            march_o: "",
            april_o: "",
            may_o: "",
            june_o:"",
            stockprocurementWithoutFilter:[],
            isEditClicked: false,
            StockViewIdFilter:"",
            FiscalYearOFilter:"",
            RegionNameOFilter:"",
            WarehouseNameOFilter:"",
            ProductIdOFilter:"",
            ProductDescriptionOFilter:"",
            ItemTypeNameOFilter:"",
            fiscalYear:"",
            fiscalMonth:"",
            purchasedContainers : [],
  
            SapcodeDupNames:[],
            SapcodeDupDescriptionNames:[],
            SapcodeNames:[],
            SapcodeDescriptionNames:[],
  
            transfertpodelayid: 0,
            transfertpodelay: "",
            transfertpodelayids: [],
            transfertpodelays:[]
            
  
        }
    }
  
  
    getCurrentFinancialYearAndMonth() {
      const today = new Date();
      let fiscalYear = "";
      let fiscalMonth = "";
    
      // Determine fiscal year
      if ((today.getMonth() + 1) <= 6) {
        fiscalYear = (today.getFullYear());
      } else {
        fiscalYear = today.getFullYear() + 1;
      }
    
      // Determine fiscal month
      fiscalMonth = (today.getMonth() + 1); // Adding 1 as months are 0-indexed
    
      return {
        fiscalYear: fiscalYear,
        fiscalMonth: fiscalMonth
      };
    }
    
      
    calculateDateFromFiscal(fiscalYear, fiscalMonth, leadTime) {
    
      // Convert fiscalYear to integer
      fiscalYear = parseInt(fiscalYear);
      // Subtract lead time from fiscal month
      let adjustedFiscalMonth = fiscalMonth - leadTime;
      adjustedFiscalMonth = Math.ceil(adjustedFiscalMonth); // Round up to the nearest integer
    
      // fiscal month between january and june
      if (adjustedFiscalMonth >= 1 && fiscalMonth <=6) {
          adjustedFiscalMonth = adjustedFiscalMonth;
          fiscalYear = fiscalYear;
          ;
      }
    
      // fiscal month between january and june
      if (adjustedFiscalMonth < 1 && fiscalMonth <=6) {
        adjustedFiscalMonth += 12;
        fiscalYear--;
        ;
    }
    
       // fiscal month between july and december
       if (adjustedFiscalMonth > 1 && fiscalMonth >=7) {
        adjustedFiscalMonth = adjustedFiscalMonth;
        fiscalYear--;
        ;
    }
    
     // fiscal month between july and december
     if (adjustedFiscalMonth < 1 && fiscalMonth >=7) {
      adjustedFiscalMonth += 12 ;
      fiscalYear--;
      fiscalYear--;
      ;
    }
    
      if (adjustedFiscalMonth < 1 && leadTime > 12) {
        adjustedFiscalMonth += 12;
        fiscalYear= fiscalYear - 2 ;
        ;
    }
    
      // Determine calendar month and year
      let calendarMonth = adjustedFiscalMonth;
      let calendarYear = fiscalYear;
    
      // Adjust calendar year if the month is greater than 12
      if (calendarMonth > 12) {
          calendarMonth -= 12;
          calendarYear++;
      }
    
      // Return the calculated date
      return {
          year: calendarYear,
          month: calendarMonth
      };
    }
    
    
    formatCalculatedDate(calculatedDate) {
      // Format the date with day 28
      return `${calculatedDate.month}/${calculatedDate.year}`;
    }
    
    
    compareDates(date1, date2) {
        // Split the dates into month and year components
        const [month1, year1] = date1.split('/');
        const [month2, year2] = date2.split('/');
    
        // Convert month and year strings to numbers for comparison
        const monthNum1 = parseInt(month1, 10);
        const yearNum1 = parseInt(year1, 10);
        const monthNum2 = parseInt(month2, 10);
        const yearNum2 = parseInt(year2, 10);
    
        // Compare years first
        if (yearNum1 > yearNum2) {
            return 1; // date1 is later than date2
        } else if (yearNum1 < yearNum2) {
            return -1; // date1 is earlier than date2
        } else {
            // If years are equal, compare months
            if (monthNum1 > monthNum2) {
                return 1; // date1 is later than date2
            } else if (monthNum1 < monthNum2) {
                return -1; // date1 is earlier than date2
            } else {
                return 0; // Both dates are equal
            }
        }
    }
    
  
  
  
    FilterFn(){
      var TransfertIdFilter = this.state.TransfertIdFilter;
      var ProductIdFilter = this.state.ProductIdFilter;
      var ProductDescriptionFilter = this.state.ProductDescriptionFilter;
      var ItemTypeFilter = this.state.ItemTypeFilter;
      var FiscalYearFilter = this.state.FiscalYearFilter;
      var FromWarehouseNameFilter = this.state.FromWarehouseNameFilter;
      var ToWarehouseNameFilter = this.state.ToWarehouseNameFilter;
      var TransfertCommentFilter = this.state.TransfertCommentFilter;
  
      var filteredData=this.state.transfertsWithoutFilter.filter(
          function(el){
              return el.from_warehouse?.warehousename.toString().toLowerCase().includes(
                  FromWarehouseNameFilter.toString().trim().toLowerCase()
              )&& 
              el.to_warehouse?.warehousename.toString().toLowerCase().includes(
                ToWarehouseNameFilter.toString().trim().toLowerCase()
            )&&  
                  el.year?.fyname.toString().toLowerCase().includes(
                  FiscalYearFilter.toString().trim().toLowerCase()
              )&&  
                  el.product?.productdescription.toString().toLowerCase().includes(
                  ProductDescriptionFilter.toString().trim().toLowerCase()
              )&&  
                  el.transfertid.toString().toLowerCase().includes(
                  TransfertIdFilter.toString().trim().toLowerCase()
              )&&  
              el.product?.sapcode.toString().toLowerCase().includes(
              ProductIdFilter.toString().trim().toLowerCase()
          )&&  
          el.product?.itemtype?.itemtypename.toString().toLowerCase().includes(
          ItemTypeFilter.toString().trim().toLowerCase()
      )
          }
      );
  
      this.setState({transferts:filteredData});
  
  }
  
  
  
  sortResult(prop,asc){
    var sortedData=this.state.forecastsWithoutFilter.sort(function(a,b){
        if(asc){
            return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
        }
        else{
            return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
        }
    });
  
    this.setState({forecasts:sortedData});
  
  }
  
  
  
  FilterFnO(){
    var RegionNameOFilter = this.state.RegionNameOFilter;
    var WarehouseNameOFilter = this.state.WarehouseNameOFilter;
    var FiscalYearOFilter = this.state.FiscalYearOFilter;
    var ProductDescriptionOFilter = this.state.ProductDescriptionOFilter;
    var StockViewIdFilter = this.state.StockViewIdFilter;
    var ItemTypeName0Filter = this.state.ItemTypeNameOFilter;
    var ProductIdOFilter = this.state.ProductIdOFilter;
  
  
    var filteredData=this.state.stockprocurementWithoutFilter.filter(
        function(el){
            return el.warehousename_o.toString().toLowerCase().includes(
                WarehouseNameOFilter.toString().trim().toLowerCase()
            )&&  
                el.fyname_o.toString().toLowerCase().includes(
                FiscalYearOFilter.toString().trim().toLowerCase()
            )&&  
                el.stockviewid.toString().toLowerCase().includes(
                StockViewIdFilter.toString().trim().toLowerCase()
            )&&  
            el.regionname_o.toString().toLowerCase().includes(
              RegionNameOFilter.toString().trim().toLowerCase()
        )&&  
        el.productdescription_o.toString().toLowerCase().includes(
          ProductDescriptionOFilter.toString().trim().toLowerCase()
    )&&  
    el.itemtypename_o.toString().toLowerCase().includes(
      ItemTypeName0Filter.toString().trim().toLowerCase()
  )&&  
  el.sapcode_o.toString().toLowerCase().includes(
    ProductIdOFilter.toString().trim().toLowerCase()
  )
        }
    );
  
    this.setState({stockprocurement:filteredData});
  
  }
  
  sortResultO(prop,asc){
  var sortedData=this.state.stockprocurementWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });
  
  this.setState({stockprocurement:sortedData});
  
  }
  
  
  
  changeCountryNameFilter = (e)=>{
    this.state.CountryNameFilter=e.target.value;
    this.FilterFn();
  }
  
  
  
  changeRegionNameFilter = (e)=>{
      this.state.RegionNameFilter=e.target.value;
      this.FilterFn();
    }
  
  
  
  changeFromWarehouseNameFilter = (e)=>{
      this.state.FromWarehouseNameFilter=e.target.value;
      this.FilterFn();
    }
  
    changeToWarehouseNameFilter = (e)=>{
      this.state.ToWarehouseNameFilter=e.target.value;
      this.FilterFn();
    }
  
  
  changeFiscalYearFilter = (e)=>{
      this.state.FiscalYearFilter=e.target.value;
      this.FilterFn();
    }
  
  
  
  changeProductDescriptionFilter = (e)=>{
      this.state.ProductDescriptionFilter=e.target.value;
      this.FilterFn();
    }
  
    changeProductIdFilter = (e)=>{
      this.state.ProductIdFilter=e.target.value;
      this.FilterFn();
    }
  
  
  
  
    changeItemTypeFilter = (e)=>{
      this.state.ItemTypeFilter=e.target.value;
      this.FilterFn();
    }
  
  changeTransfertIdFilter = (e)=>{
      this.state.TransfertIdFilter=e.target.value;
      this.FilterFn();
    }
  
    changeWarehouseNameOFilter = (e)=>{
      this.state.WarehouseNameOFilter=e.target.value;
      this.FilterFnO();
    }
  
  
    changeRegionNameOFilter = (e)=>{
      this.state.RegionNameOFilter=e.target.value;
      this.FilterFnO();
    }
  
    changeFiscalYearOFilter = (e)=>{
      this.state.FiscalYearOFilter=e.target.value;
      this.FilterFnO();
    }
  
    changeItemTypeNameOFilter = (e)=>{
      this.state.ItemTypeNameOFilter=e.target.value;
      this.FilterFnO();
    }
  
    changeProductDescriptionOFilter = (e)=>{
      this.state.ProductDescriptionOFilter=e.target.value;
      this.FilterFnO();
    }
  
    
    changeProductIdOFilter = (e)=>{
      this.state.ProductIdOFilter=e.target.value;
      this.FilterFnO();
    }
  
    changeStockViewIdFilter = (e)=>{
      this.state.StockViewIdFilter=e.target.value;
      this.FilterFnO();
    }
  
  refreshList = () => {
      axiosService.get('/transferts/')
        .then((response) => {
          const data = response.data?.results ?? response.data;
          this.setState({ transferts: data, transfertsWithoutFilter: data, loading: false });
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
          this.setState({ loading: false });
        });
    };
  
  
    refreshListProcurement = () => {
      axiosService.get('/stockprocurement/')
        .then((response) => {
          const data = response.data?.results ?? response.data;
          this.setState({ stockprocurement: data, stockprocurementWithoutFilter: data, loading: false });
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
          this.setState({ loading: false });
        });
    };
  
  
  fetchRegionNames() {
    axiosService.get('/regionnames/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const regionNames = data.map(item => item.regionname);
        this.setState({ regionNames: regionNames });
      })
      .catch(error => {
        console.error("Error fetching region names:", error);
      });
  }
  
  
  fetchCountryNames() {
    axiosService.get('/countries/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const filteredData = data.filter(item => item.isactive === true);
        const countryNames = filteredData.map(item => item.countryname);
        this.setState({ countryNames: countryNames });
      })
      .catch(error => {
        console.error("Error fetching country names:", error);
      });
  }
  
  fetchFiscalYears() {
      axiosService.get('/years/')
        .then(response => {
          const data = response.data?.results ?? response.data;
          const filteredData = data.filter(item => item.isactive === true);
          const fiscalYears = filteredData.map(item => item.fyname);
          this.setState({ fiscalYears: fiscalYears });
        })
        .catch(error => {
          console.error("Error fetching fiscal years:", error);
        });
  }
  
    fetchProductDescriptions() {
      axiosService.get('/defaultproducts/')
        .then(response => {
          const data = response.data?.results ?? response.data;
          const filteredData = data.filter(item => item.isactive === true);
          const productdescriptions = filteredData.map(item => item.productdescription);
          this.setState({ productdescriptions: productdescriptions });
        })
        .catch(error => {
          console.error("Error fetching products :", error);
        });
    }
  
    fetchWarehouseNames() {
      axiosService.get('/warehouses/')
        .then(response => {
          const data = response.data?.results ?? response.data;
          const filteredData = data.filter(item => item.isactive === true);
          const warehouseNames = filteredData.map(item => item.warehousename);
          this.setState({ warehouseNames: warehouseNames });
        })
        .catch(error => {
          console.error("Error fetching warehouse names:", error);
        });
    }
  
    fetchToWarehouseNames() {
      axiosService.get('/warehouses/')
        .then(response => {
          const data = response.data?.results ?? response.data;
          const filteredData = data.filter(item => item.isactive === true);
          const toWarehouseNames = filteredData.map(item => item.warehousename);
          this.setState({ toWarehouseNames: toWarehouseNames });
        })
        .catch(error => {
          console.error("Error fetching warehouse names:", error);
        });
    }
  
  handleInput = (event) => {
      const inputValue = event.target.value;
      const regex = /^\d*$/;
      if (!regex.test(inputValue)) {
        event.target.value = inputValue.replace(/[^0-9]/g, '');
      }
    };
  
    fetchProducts() {
      axiosService.get('/defaultproductscreate/') // Replace with the appropriate API endpoint for products
        .then((response) => {
          const data = response.data?.results ?? response.data;
          // Filter the data where purchasetypeid is equal to 1
          const filteredData = data.filter((item) => item.productlabelid === 1 && item.isactive === true);
    
          // Extract unique warehouseid values from the filtered data
          const products = filteredData.map((item) => item.productdescription);
    
          this.setState({ products: products });
        })
        .catch((error) => {
          console.error('Error fetching Products data:', error);
        });
    }
  
    fetchKits() {
      axiosService.get('/defaultproductscreate/') // Replace with the appropriate API endpoint for products
        .then((response) => {
          const data = response.data?.results ?? response.data;
          // Filter the data where purchasetypeid is equal to 1
          const filteredData = data.filter((item) => item.productlabelid === 2 &&  item.isactive === true);
    
          // Extract unique warehouseid values from the filtered data
          const kits = filteredData.map((item) => item.productdescription);
    
          this.setState({ kits: kits });
        })
        .catch((error) => {
          console.error('Error fetching Products data:', error);
        });
    }
  
    fetchProductLables() {
      axiosService.get('/productlabels/') // Replace with the appropriate API endpoint for products
        .then((response) => {
          const data = response.data?.results ?? response.data;
         
          const productLabels = data.map((item) => item.productlabelname);
    
          this.setState({ productLabels: productLabels });
        })
        .catch((error) => {
          console.error('Error fetching ProductLabels data:', error);
        });
    }
  
    formatUpdateDate(update_y) {
      if (!update_y) {
        return 'N/A'; // Handle the case where update_y is not available
      }
  
      const parsedDate = new Date(update_y);
      const formattedDate = parsedDate.toLocaleDateString(); // Adjust the format as needed
  
      return formattedDate;
    }
  
      
  fetchSapcodeDupNames() {
    axiosService.get('/defaultkits/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const filteredData = data.filter(item => item.isactive === true);
        const SapcodeDupNames = filteredData.map(item => item.sapcodedup);
  
        const sapcodeToProductDescriptionMap = {};
        filteredData.forEach(item => {
          sapcodeToProductDescriptionMap[item.sapcodedup] = item.productdescription;
        });
  
        this.setState({ SapcodeDupNames: SapcodeDupNames,SapcodeDupDescriptionNames:sapcodeToProductDescriptionMap  });
      })
      .catch(error => {
        console.error("Error fetching product sapcode:", error);
      });
  }
  
  findProductDescriptionForSapcodeDup(sapcodedup) {
    const productDescriptionMap = this.state.SapcodeDupDescriptionNames;
    return productDescriptionMap[sapcodedup] || "Kit not found";
  }
  
  
  fetchProductNames() {
    axiosService.get('/defaultitems/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const filteredData = data.filter(item => item.isactive === true);
        const productNames = filteredData.map(item => item.productdescription);
        this.setState({ productNames: productNames });
      })
      .catch(error => {
        console.error("Error fetching product names:", error);
      });
  }
  
  fetchSapcodeNames() {
    axiosService.get('/defaultitems/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const filteredData = data.filter(item => item.isactive === true);
        const SapcodeNames = filteredData.map(item => item.sapcode);
  
        const sapcodeToProductDescriptionMap = {};
        filteredData.forEach(item => {
          sapcodeToProductDescriptionMap[item.sapcode] = item.productdescription;
        });
  
        this.setState({ SapcodeNames: SapcodeNames,SapcodeDescriptionNames:sapcodeToProductDescriptionMap  });
      })
      .catch(error => {
        console.error("Error fetching product sapcode:", error);
      });
  }
  
  findProductDescriptionForSapcode(sapcode) {
    const productDescriptionMap = this.state.SapcodeDescriptionNames;
    return productDescriptionMap[sapcode] || "Product not found";
  }
  
  fetchTransfertPoDelay() {
    axiosService.get('/transfertpodelay/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const transfertpodelayIDS = data.map(item => item.transfertpodelayid);
  
        const transfertPoDelayMap = {};
        data.forEach(item => {
          transfertPoDelayMap[item.transfertpodelayid] = item.transfertpodelay;
        });
  
        this.setState({ transfertpodelayids: transfertpodelayIDS,transfertpodelays:transfertPoDelayMap  });
      })
      .catch(error => {
        console.error("Error fetching transfertpo ids:", error);
      });
  }
  
  findTransfertPoDelayID(transfertpodelayid) {
    const transfertPoDelayMap = this.state.transfertpodelays;
    return transfertPoDelayMap[transfertpodelayid] || "transfertpodelay not found";
  }
  
  
  componentDidMount(){
    this.refreshList();
 
    this.fetchTransfertPoDelay();
  }
  

 
  
  
  

  
  
  render(){
    const {
        transferts,
        modalTitle,
        transfertid,
        from_warehousename,
        to_warehousename,
        fyname,
        productdescription,
        july,
        august,
        september,
        october,
        november,
        december,
        january,
        february,
        march,
        april,
        may,
        june,
        comment,
        povalidatedjuly,
        povalidatedaugust,
        povalidatedseptember,
        povalidatedoctober,
        povalidatednovember,
        povalidateddecember,
        povalidatedjanuary,
        povalidatedfebruary,
        povalidatedmarch,
        povalidatedapril,
        povalidatedmay,
        povalidatedjune,
        products,
        kits,
        productlabelname,
        forecastshistory,
        transfertid_o,
        countryname_o,
        
        comment_o,
        modifiedat_o,
        loading,
        fiscalYears,
  
        stockprocurement,
  
        stockviewid,
        fyname_o,
        regionname_o,
        warehousename_o,
        productdescription_o,
        itemtypename_o,
        july_o,
        august_o,
        september_o,
        october_o,
        november_o,
        december_o,
        january_o,
        february_o,
        march_o,
        april_o,
        may_o,
        june_o,
        isEditClicked
  
    }=this.state;
  
    return(
      
<div className="scrollable-container">
<MyPage />
<SubTabsWarehouses />

<div className="table-container">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">
<th  style={{  fontSize: "12px" ,textAlign:"center"}}>
      <div className="d-flex flex-row align-items-center justify-content-center"
      
      >
      <input className="form-control m-2"
      style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeTransfertIdFilter}
      placeholder="Filter"/>

      </div>
      TransfertId
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "90px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeProductIdFilter}
      placeholder="Filter"/>
      </div>
     SAP Code / SKU
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "100px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeProductDescriptionFilter}
      placeholder="Filter"/>

      </div>
      Product
  </th>


  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "100px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeItemTypeFilter}
      placeholder="Filter"/>
      </div>
      ItemType
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeFiscalYearFilter}
      placeholder="Filter"/>
      </div>
      Fiscal Year
  </th>


  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "100px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeFromWarehouseNameFilter}
      placeholder="Filter"/>
      </div>
      From Warehouse
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "100px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeToWarehouseNameFilter}
      placeholder="Filter"/>
      </div>
      To Warehouse
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      LeadTime(months)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jul
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Aug
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Sep
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Oct
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Nov
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Dec
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jan
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Feb
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Mar
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Apr
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      May
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jun
  </th>

</tr>
</thead>
{loading ? (
          <div style={{ display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width:'150vh' }}>
            {/* Use react-loader-spinner here */}
            <Blocks visible={true} height="100" width="100" ariaLabel="blocks-loading" wrapperStyle={{}} wrapperClass="blocks-wrapper"/>
            <div style={{ marginLeft: '10px' }}>Loading...</div>
          </div>
        ) : (
<tbody>
  {transferts.map(dep=> {

    const leadTime = this.findTransfertPoDelayID(1);
  
    const calculatedDateJuly = this.calculateDateFromFiscal(dep.year.fyname, 7, leadTime);
    const formattedJuly = this.formatCalculatedDate(calculatedDateJuly);
    const calculatedDateAugust = this.calculateDateFromFiscal(dep.year.fyname, 8, leadTime);
    const formattedAugust = this.formatCalculatedDate(calculatedDateAugust);
    const calculatedDateSeptember = this.calculateDateFromFiscal(dep.year.fyname, 9, leadTime);
    const formattedSeptember = this.formatCalculatedDate(calculatedDateSeptember);
    const calculatedDateOctober = this.calculateDateFromFiscal(dep.year.fyname, 10, leadTime);
    const formattedOctober = this.formatCalculatedDate(calculatedDateOctober);
    const calculatedDateNovember = this.calculateDateFromFiscal(dep.year.fyname, 11, leadTime);
    const formattedNovember = this.formatCalculatedDate(calculatedDateNovember);
    const calculatedDateDecember = this.calculateDateFromFiscal(dep.year.fyname, 12, leadTime);
    const formattedDecember = this.formatCalculatedDate(calculatedDateDecember);
    const calculatedDateJanuary = this.calculateDateFromFiscal(dep.year.fyname, 1, leadTime);
    const formattedJanuary = this.formatCalculatedDate(calculatedDateJanuary);
    const calculatedDateFebruary = this.calculateDateFromFiscal(dep.year.fyname, 2, leadTime);
    const formattedFebruary = this.formatCalculatedDate(calculatedDateFebruary);
    const calculatedDateMarch = this.calculateDateFromFiscal(dep.year.fyname, 3, leadTime);
    const formattedMarch  = this.formatCalculatedDate(calculatedDateMarch);
    const calculatedDateApril = this.calculateDateFromFiscal(dep.year.fyname, 4, leadTime);
    const formattedApril  = this.formatCalculatedDate(calculatedDateApril);
    const calculatedDateMay = this.calculateDateFromFiscal(dep.year.fyname, 5, leadTime);
    const formattedMay  = this.formatCalculatedDate(calculatedDateMay);
    const calculatedDateJune = this.calculateDateFromFiscal(dep.year.fyname, 6, leadTime);
    const formattedJune  = this.formatCalculatedDate(calculatedDateJune);

    // Get the current date
    const currentDate = new Date();

    // Extract month and year from the current date
    const currentMonth = currentDate.getMonth() + 1; // Adding 1 because months are zero-based
    const currentYear = currentDate.getFullYear();

    // Format the month/year string
    const formattedDate = `${currentMonth}/${currentYear}`;


    

  return (
      <tr key={dep.transfertid} className="row-hover">
          <td className="table-text">{dep.transfertid}</td>
          <td className="table-text">{dep.product?.sapcode ?? 'N/A'}</td>
          <td className="table-text">{dep.product?.productdescription ?? 'N/A'}</td>
          <td className="table-text">{dep.product?.itemtype?.itemtypename ?? 'N/A'}</td>
          <td className="table-text">{dep.year?.fyname ?? 'N/A'}</td>
          <td className="table-text">{dep.from_warehouse?.warehousename ?? 'N/A'}</td>
          <td className="table-text">{dep.to_warehouse?.warehousename ?? 'N/A'}</td>
          <td className="table-text">{leadTime}</td>
          <td className={`table-text ${dep.july ? (dep.povalidatedjuly ? 'text-success'   : (this.compareDates(formattedDate, formattedJuly) !== 0 || 1 ? 'text-warning':'') ) : ''}`}>{dep.july ? (dep.povalidatedjuly ? "Po OK" : formattedJuly) : 'N/A'}</td>
          <td className={`table-text ${dep.august ? (dep.povalidatedaugust ? 'text-success'   : (this.compareDates(formattedDate, formattedAugust) !== 0 || 1 ? 'text-warning':'') ) : ''}`}>{dep.august ? (dep.povalidatedaugust ? "Po OK" : formattedAugust) : 'N/A'}</td>
          <td className={`table-text ${dep.september ? (dep.povalidatedseptember ? 'text-success'   : (this.compareDates(formattedDate, formattedSeptember) !== 0 || 1 ? 'text-warning':'') ) : ''}`}>{dep.september ? (dep.povalidatedseptember ? "Po OK" : formattedSeptember) : 'N/A'}</td>
          <td className={`table-text ${dep.october ? (dep.povalidatedoctober ? 'text-success'   : (this.compareDates(formattedDate, formattedOctober) !== 0 || 1 ? 'text-warning':'') ) : ''}`}>{dep.october ? (dep.povalidatedoctober ? "Po OK" : formattedOctober) : 'N/A'}</td>
          <td className={`table-text ${dep.november ? (dep.povalidatednovember ? 'text-success'   : (this.compareDates(formattedDate, formattedNovember) !== 0 || 1 ? 'text-warning':'') ) : ''}`}>{dep.november ? (dep.povalidatednovember ? "Po OK" : formattedNovember) : 'N/A'}</td>
          <td className={`table-text ${dep.december ? (dep.povalidateddecember ? 'text-success'   : (this.compareDates(formattedDate, formattedDecember) !== 0 || 1 ? 'text-warning':'') ) : ''}`}>{dep.december ? (dep.povalidateddecember ? "Po OK" : formattedDecember) : 'N/A'}</td>
          <td className={`table-text ${dep.january ? (dep.povalidatedjanuary ? 'text-success'   : (this.compareDates(formattedDate, formattedJanuary) !== 0 || 1 ? 'text-warning':'') ) : ''}`}>{dep.january ? (dep.povalidatedjanuary ? "Po OK" : formattedJanuary) : 'N/A'}</td>
          <td className={`table-text ${dep.february ? (dep.povalidatedfebruary ? 'text-success'   : (this.compareDates(formattedDate, formattedFebruary) !== 0 || 1 ? 'text-warning':'') ) : ''}`}>{dep.february ? (dep.povalidatedfebruary ? "Po OK" : formattedFebruary) : 'N/A'}</td>
          <td className={`table-text ${dep.march ? (dep.povalidatedmarch ? 'text-success'   : (this.compareDates(formattedDate, formattedMarch) !== 0 || 1 ? 'text-warning':'') ) : ''}`}>{dep.march ? (dep.povalidatedmarch ? "Po OK" : formattedMarch) : 'N/A'}</td>
          <td className={`table-text ${dep.april ? (dep.povalidatedapril ? 'text-success'   : (this.compareDates(formattedDate, formattedApril) !== 0 || 1 ? 'text-warning':'') ) : ''}`}>{dep.april ? (dep.povalidatedapril ? "Po OK" : formattedApril) : 'N/A'}</td>
          <td className={`table-text ${dep.may ? (dep.povalidatedmay ? 'text-success'   : (this.compareDates(formattedDate, formattedMay) !== 0 || 1 ? 'text-warning':'') ) : ''}`}>{dep.may ? (dep.povalidatedmay ? "Po OK" : formattedMay) : 'N/A'}</td>
          <td className={`table-text ${dep.june ? (dep.povalidatedjune ? 'text-success'   : (this.compareDates(formattedDate, formattedJune) !== 0 || 1 ? 'text-warning':'') ) : ''}`}>{dep.june ? (dep.povalidatedjune ? "Po OK" : formattedJune) : 'N/A'}</td>
          <td className="table-text">

          </td>
      </tr>

);
   } )}
</tbody>
 )
}
</table>
</div>



</div>
    )
  }
  }




